import { WidgetComponent } from "../widget.component";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { EditableWidget, WIDGET_WHITEBOARD } from "@shared/models/widget";
import * as url from "url";
import { SessionStorage } from "@shared/SessionStorage";
import { NameService } from "@shared/services/name.service";
import { FE_WhiteBoardWidget } from "@shared/models/integration";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";
import { ConfigScreenWidgetComponent } from "../config-screen/config-screen.widget.component";
import { FieldComponent } from "../../../elements/field/field.component";

@Component({
    templateUrl: "whiteboard.widget.component.html",
    styleUrls: ["whiteboard.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenWidgetComponent, FieldComponent, TranslatePipe]
})
export class WhiteboardWidgetComponent extends WidgetComponent {
    private readonly whiteBoardWidget: FE_WhiteBoardWidget = <FE_WhiteBoardWidget>SessionStorage.editIntegration;

    constructor(private readonly nameService: NameService, public translate: TranslateService, logService: LogService) {
        super(WIDGET_WHITEBOARD, "Whiteboard", translate, logService, "generic", "whiteboard", "boardName");
    }

    protected OnWidgetsDiscovered(widgets: EditableWidget[]): void {
        for (const widget of widgets) {
            if (!widget.dimension.newUrl.startsWith("http://") && !widget.dimension.newUrl.startsWith("https://")) {
                const parsedUrl = url.parse(widget.url, true);
                const boardName = parsedUrl.query["boardName"];

                // Set the new URL so that it unpacks correctly
                widget.url = `https://cloud13.de/testwhiteboard/?whiteboardid=${boardName}`;
            }
        }
    }

    protected OnNewWidgetPrepared(widget: EditableWidget): void {
        const name = this.nameService.getHumanReadableName();

        let template = "https://cloud13.de/testwhiteboard/?whiteboardid=$roomId_$boardName";
        if (this.whiteBoardWidget.options?.defaultUrl) {
            template = this.whiteBoardWidget.options.defaultUrl;
        }

        template = template.replace("$roomId", encodeURIComponent(SessionStorage.roomId));
        template = template.replace("$boardName", encodeURIComponent(name));

        widget.dimension.newUrl = template;
        widget.dimension.newName = name;
    }
}
